/**
 * Copy del panel de valor en login (opción C del proto).
 * Fuente: documentacion/design/prototypes/login-enrichment-options-v1.html
 */
export const LOGIN_VALUE_TITLE = 'Vendé en el local. Vendé online.';
export const LOGIN_VALUE_SUB = 'Creá tu tienda y cargá tus productos.';
export const LOGIN_VALUE_BULLETS = [
  'Elegí tu rubro',
  'Decí cómo operás',
  'Completá el catálogo y listo',
] as const;
export const LOGIN_VALUE_FOOTER = 'Todo tu negocio, en un solo lugar.';
